// TODO: migrate to @raydiant/raydial icon
import { SVGProps } from 'react';

interface FolderMagnifyingGlassIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

const FolderMagnifyingGlassIcon = ({
  size = 17,
  ...props
}: FolderMagnifyingGlassIconProps) => {
  const height = (size * 15) / 17;
  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.33398 3.1875L6.90625 1.75977L8.03516 0.630859L6.90625 1.75977C6.80664 1.66016 6.67383 1.59375 6.54102 1.59375H2.125C1.82617 1.59375 1.59375 1.85938 1.59375 2.125V12.75C1.59375 13.0488 1.82617 13.2812 2.125 13.2812H14.875C15.1406 13.2812 15.4062 13.0488 15.4062 12.75V4.25C15.4062 3.98438 15.1406 3.71875 14.875 3.71875H9.66211C9.16406 3.71875 8.69922 3.55273 8.33398 3.1875ZM9.46289 2.05859C9.5293 2.125 9.5957 2.125 9.66211 2.125H14.875C16.0371 2.125 17 3.08789 17 4.25V12.75C17 13.9453 16.0371 14.875 14.875 14.875H2.125C0.929688 14.875 0 13.9453 0 12.75V2.125C0 0.962891 0.929688 0 2.125 0H6.54102C7.10547 0 7.63672 0.232422 8.03516 0.630859L9.46289 2.05859ZM11.1562 7.96875H11.123C11.123 8.56641 10.9902 9.13086 10.6914 9.5957L11.9531 10.8906C12.2852 11.1895 12.2852 11.6875 11.9531 12.0195C11.6543 12.3184 11.1562 12.3184 10.8574 12.0195L9.5625 10.7246C9.09766 11.0234 8.5332 11.1562 7.96875 11.1562C6.20898 11.1562 4.78125 9.72852 4.78125 7.96875C4.78125 6.20898 6.20898 4.78125 7.96875 4.78125C9.72852 4.78125 11.1562 6.20898 11.1562 7.96875ZM7.96875 6.375C7.37109 6.375 6.87305 6.70703 6.57422 7.17188C6.27539 7.66992 6.27539 8.30078 6.57422 8.76562C6.87305 9.26367 7.37109 9.5625 7.96875 9.5625C8.5332 9.5625 9.03125 9.26367 9.33008 8.76562C9.62891 8.30078 9.62891 7.66992 9.33008 7.17188C9.03125 6.70703 8.5332 6.375 7.96875 6.375Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FolderMagnifyingGlassIcon;
